// @flow

import { connect } from 'react-redux';

import { createChallenge } from 'app/actions/h2hActions';
import LineUpBuilder from 'app/components/challenge/LineUpBuilder';

function mapStateToProps() {
  return {
    isChallengeBuilder: true,
    isH2H: true
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit(...args) {
      dispatch(createChallenge(...args));
    }
  };
}

function mergeProps(stateProps, { onSubmit, ...restDispatchProps }, ownProps) {
  return {
    ...stateProps,
    ...restDispatchProps,
    ...ownProps,
    onSubmit() {
      onSubmit({
        name: ownProps.challengeName,
        slate_id: ownProps.slateId,
        total_fee: ownProps.entryFee,
        quantity: ownProps.numChallengesToCreate,
        type: ownProps.challengeType,
        private: ownProps.isPrivate,
        maximum_entries: ownProps.maxNumEntries,
        pay_structure: ownProps.prizeStructure,
        maximum_entries_per_user: ownProps.maxNumEntriesPerUser
      });
    }
  };
}

const CreateChallengeLineUpBuilder = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(LineUpBuilder);

export default CreateChallengeLineUpBuilder;
